<template>
    <div class="newsList">
        <!-- 新区要闻 -->
        <!-- 内容区 -->
        <div class="content">
            <div class="chanpincon">
                <div class="inner">
                    <div class="childnav">
                        <div class="desc">
                            <img src="/statics/image/index/icon.png" alt />
                            <span>{{ cateact.title }}</span>
                        </div>
                        <el-tabs :tab-position="tabPosition" v-model="activeName" @tab-click="handleClick"
                            v-if="cateact && cateact.s_cates">
                            <el-tab-pane v-for="(item, index) in cateact.s_cates" :key="index" :name="item.id.toString()">
                                <a href="javascript:scroll(0,0)" slot="label" v-if="item.link_flag != 1"
                                    :style="!item.display ? 'display: none;' : ''">{{ item.title ? item.title : '' }}</a>
                                <a :href="item.url" slot="label" v-if="item.link_flag == 1"
                                    :style="!item.display ? 'display: none;' : ''">{{ item.title ? item.title : '' }}</a>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                    <!-- <div class="news_right" v-if="parseInt(activeName)==5464">
            <iframe
              src="http://www.gov.cn/pushinfo/v150203/base_14px_pubdate.htm"
              width="100%"
              height="100%"
              style="padding-bottom: 20px; padding-left: 20px; height: 290px;"
            ></iframe>
          </div> -->
                    <div class="news_right" v-if="parseInt(activeName) == 5464" id="gwy">

                    </div>
                    <div class="news_right" v-else-if="article">
                        <div class="gg_list">
                            <!-- <div class="gg_item act" @click="toInfo">
                <div class="gg">
                  <span>[公告] 详细分析排烟风机怎么会渗水?</span>
                </div>
                <div class="time">
                  <span>2022年2月26日</span>
                  <img src="/statics/image/index/gg_jiantou.png" alt />
                </div>
              </div>-->
                            <div class="gg_item" v-for="(item, index) in article.articlelist" :key="index"
                                @click="toInfo(activeName, item, item.article_id, item.link_flag)">
                                <div class="gg">
                                    <span>[公告] {{ item.article_title }}</span>
                                </div>
                                <div class="time">
                                    <span>{{ item.publish_at }}</span>
                                    <img src="/statics/image/index/gg_jiantou.png" alt />
                                </div>
                            </div>
                        </div>
                        <!-- 分页 -->
                        <div class="fenye clearfix" v-if="article.articlelist.length != 0 && activeName != 5464">
                            <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage"
                                :page-size="pages.size" layout="prev, pager, next, jumper" :total="newsTotal"
                                prev-text="上一页" next-text="下一页"></el-pagination>
                        </div>
                        <!-- <div class="lxTel" v-if="activeName == '5554'">
              <img src="/statics/image/index/tel.png" alt />
              <span>联系电话：2126632</span>
            </div>-->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isFirst: true, //是否第一次进
            tabPosition: "left", //导航对齐方式
            activeName: null,
            currentPage: 1, //当前页数
            pages: {
                page: 1,
                size: 10
            },
            newsTotal: 0, //总条数
            nowid: "",
            nowindex: "",
            // s_cates: [], //二级分类
            cateact: { title: "" },
            article: null,
            fromName: "",
            topvalue: ""
        };
    },
    created() {
        console.log("created");
        // console.log("created", this.cateact);
        if (localStorage.getItem("topvalue")) {
            this.topvalue = localStorage.getItem("topvalue");
        }
        if (localStorage.getItem("tabvalue")) {
            this.activeName = localStorage.getItem("tabvalue");
        }
        this.nowid = this.$route.query.id;
        this.nowindex = this.$route.query.index;

        // console.log("created", this.nowindex);
        this.getNav();
        // $("html,body").animate({ scrollTop: 0 }, "slow"); //顶部
    },
    methods: {
        // 获取导航
        getNav() {
            this.article = null;
            this.nowid = this.$route.query.id;
            this.nowindex = this.$route.query.index;
            // console.log("getNav", this.nowindex);
            var that = this;
            that.$api.index.catelist({}).then(function (res) {
                if (res.code == 200) {
                    // that.cateact = res.result[that.nowindex];
                    for (var i in res.result.all_cate) {
                        if (res.result.all_cate[i].id == that.nowid) {
                            that.cateact = res.result.all_cate[i];
                        }
                    }
                    console.log("getNav", that.cateact);
                    // console.log("that.cateact", that.cateact);
                    // if (that.isFirst) {
                    console.log("判断跳转");
                    // setTimeout(() => {
                    // for (var c in that.cateact.s_cates) {
                    //   if (that.cateact.s_cates[c].display == 1) {
                    //     if (that.cateact.s_cates[c].link_flag != 1) {
                    //       console.log("第一个有子集",c);

                    //       return;
                    //     }
                    //   }
                    // }
                    // }, 1000);
                    // setTimeout(() => {
                    //   for (var c in that.cateact.s_cates) {
                    //     if (that.cateact.s_cates[c].display == 1) {
                    //       console.log("c", c);
                    //       if (that.cateact.s_cates[c].link_flag != 1) {
                    //         that.$router.push({
                    //           path: "/xqNews_sanji",
                    //           query: {
                    //             id: that.nowid,
                    //             index: that.nowindex,
                    //             sanIndex: c,
                    //             sanId: that.cateact.s_cates[c].id
                    //           }
                    //         });
                    //       }
                    //       return;
                    //     }
                    //   }
                    // }, 300);
                    // }

                    if (localStorage.getItem("tabvalue")) {
                        that.activeName = localStorage.getItem("tabvalue");
                        that.getArticlelist();
                    } else {
                        if (
                            !that.$route.query.dhid &&
                            that.cateact &&
                            that.cateact.s_cates
                        ) {
                            // that.activeName = that.cateact.s_cates[0].id.toString();
                            for (var s in that.cateact.s_cates) {
                                if (that.cateact.s_cates[s].display != 0) {
                                    that.activeName = that.cateact.s_cates[s].id.toString();
                                    if (that.cateact.s_cates[s].is_child != 1) {
                                        that.getArticlelist();
                                    } else {
                                        var sanId = that.cateact.s_cates[s].s_cates[0].id.toString();
                                        that.getArticlelist(sanId);
                                    }
                                    break;
                                }
                            }
                        }
                        if (that.$route.query.dhid) {
                            // console.log("1");
                            that.activeName = that.$route.query.dhid.toString();
                            // localStorage.setItem("tabvalue", that.activeName);
                            that.getArticlelist();
                        }
                        console.log("that.activeName",that.activeName);
                    }

                    // that.getArticlelist();
                    that.getGuo()
                }
            });
        },
        // 文章列表
        getArticlelist(sanId) {
            var that = this;
            // console.log(that.activeName,typeof that.activeName);
            // console.log('activeName:',that.activeName)
            var ps = {
                // cate_id: that.activeName * 1,
                page: that.pages.page,
                size: that.pages.size
            };
            if (sanId && sanId != '') {
                ps.cate_id = sanId
            } else {
                ps.cate_id = that.activeName * 1
            }
            if (that.topvalue && that.topvalue != "") {
                ps.keyword = that.topvalue;
            } else {
                ps.keyword = "";
            }
            that.$api.index.articlelist(ps).then(function (res) {
                if (res.code == 200) {
                    that.article = res.result;
                    for (var i in that.article.articlelist) {
                        that.article.articlelist[
                            i
                        ].article_title = that.article.articlelist[
                            i
                        ].article_title.replaceAll("<br/>", "");
                    }
                    if (
                        that.article.articlelist.length == 0 &&
                        that.activeName != "5464"
                    ) {
                        that.$message({
                            message: "搜索结果为空！",
                            type: "warning"
                        });
                    }
                    that.newsTotal = res.result.total * 1;
                }
            });
        },
        clickGuowu() {
            console.log($("#gwy"))
            this.showGuoWu = true;
            //   console.log(this.contents)
            let that = this
            setTimeout(function () {
                $("#gwy").html(that.contents)
            }, 300)
        },
        getGuo() {
            console.log("getGuo");
            let that = this;
            var xhr = new XMLHttpRequest();
            xhr.open("GET", "https://www.gov.cn/pushinfo/v150203/pushinfo.js", false); // 文件路径
            xhr.overrideMimeType("text/html;charset=utf-8"); // 默认为utf-8
            xhr.send(null);
            // 获取文件信息(得到的数据是String)
            //  console.log("111",xhr.responseText);
            var str = xhr.responseText;
            str = str.replaceAll('document.writeln("', "");
            str = str.replaceAll('");', "");
            // console.log(str);
            that.contents = str;
            //  $("#gwy").html(str)
            if (that.activeName == 5464) {
                that.clickGuowu();
            }
        },
        // 导航选中触发
        handleClick(tab, event) {
            console.log("tab", tab.name);
            if (tab.name == 5464) {
                this.clickGuowu();
            }
            // 测试5515
            // if (tab.name != 5554) {
            console.log("handleClick", tab, event);
            // localStorage.removeItem("topvalue");
            localStorage.setItem("tabvalue", tab.name);
            // this.topvalue = "";
            // this.$store.commit("setSouvalue", { val: false });
            // 判断是否有三级
            var is_child = 0;
            var link_flag = 0;
            var sanIndex = 0;
            for (var i in this.cateact.s_cates) {
                if (this.cateact.s_cates[i].id == tab.name) {
                    is_child = this.cateact.s_cates[i].is_child;
                    sanIndex = i;
                    link_flag = this.cateact.s_cates[i].link_flag;
                }
            }
            if (link_flag != 1) {
                if (is_child == 1) {
                    this.$router.push({
                        path: "/xqNews_sanji",
                        query: {
                            id: this.nowid,
                            index: this.nowindex,
                            sanIndex: sanIndex,
                            sanId: tab.name
                        }
                    });
                } else {
                    this.getArticlelist();
                }

                this.activeName = tab.name;
                this.currentPage = 1; //当前页数
                this.pages.page = 1;
                // this.getArticlelist();
            }
            // }
        },
        // 页数改变时触发
        handleCurrentChange(val) {
            // console.log(val);
            this.pages.page = val;
            this.getArticlelist();
            $("html,body").animate({ scrollTop: 0 }, "slow"); //顶部
        },
        // 点击跳转到新区要闻详情
        toInfo(cate_id, item, id, flex) {
            if (flex == 0) {
                // console.log("跳", this.nowindex);
                this.$router.push({
                    path: "/xqNews_detail",
                    query: {
                        cate_id,
                        id: id,
                        index: this.nowindex
                        // erId: this.activeName
                    }
                });
            } else {
                window.open(item.url);
            }
        }
    },
    watch: {
        $route(to, from) {
            console.log("to", to.name);
            console.log("from", from.name);
            // this.fromName = from.name;
            // console.log(from.name != "xqNews_detail");

            // &&from.name != "ztzl"
            // console.log("to", to.name);
            // if (to.name != "xqNews") {
            localStorage.removeItem("topvalue");
            localStorage.removeItem("tabvalue");
            this.topvalue = "";
            // }
            if (to.name != "xqNews_detail" && from.name != "xqNews_detail") {
                // console.log("watch");
                this.currentPage = 1; //当前页数
                this.pages.page = 1;
                this.getNav();
            }
            // if (to.name == "xqNews") {
            //   this.article = null;
            //   this.getArticlelist();
            // }
            this.nowindex = this.$route.query.index;
            // this.getNav();
            let that = this;
            if (to.name == "xqNews" && from.name != "xqNews_sanji") {
                // 第一次进
                that.isFirst = true;
                // for (var c in that.cateact.s_cates) {
                //   if (that.cateact.s_cates[c].display == 1) {
                //     console.log("c", c);
                //     if (that.cateact.s_cates[c].link_flag != 1) {
                //       that.$router.push({
                //         path: "/xqNews_sanji",
                //         query: {
                //           id: that.nowid,
                //           index: that.nowindex,
                //           sanIndex: c,
                //           sanId: that.cateact.s_cates[c].id
                //         }
                //       });
                //     }
                //     return;
                //   }
                // }
            } else {
                that.isFirst = false;
            }
        }
    },
    mounted() {
        // console.log("activeName",this.activeName);
        // console.log("mounted", this.cateact);
        // console.log("window.history",window.history);
        // this.getGuo()
    },
    activated: function () {
        // console.log("activated", this.cateact);
        $("html,body").animate({ scrollTop: 0 }, "slow"); //顶部
        //   console.log("111");
        //   this.currentPage = 1; //当前页数
        //   this.pages.page = 1;
        //   this.getNav();
    }
};
</script>

<style lang="scss" scoped>
.lxTel {
    font-size: 0.08rem;
    position: absolute;
    right: 0;
    top: 0;
    color: #313131;
    display: flex;
    align-items: center;
    color: #306dc8;
}

.lxTel img {
    width: 20px;
    height: 20px;
    margin-right: 8px;
}

#gwy /deep/ul {
    display: block;
    width: 100%;
}

#gwy /deep/ul li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.15rem 0;
    border-bottom: 0.01rem solid rgba(166, 165, 175, 0.2);
    margin-bottom: 0.1rem;
    height: 0.42rem;
}

#gwy /deep/ul li span {
    font-size: 0.07rem;
    color: #999;
}

#gwy /deep/ul li a {
    font-size: 0.09rem;
    font-weight: bold;
    width: 4rem;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    color: #000;
}
</style>